import { render, staticRenderFns } from "./incidents-table.vue?vue&type=template&id=f0eef0c2&scoped=true"
import script from "./incidents-table.vue?vue&type=script&lang=js"
export * from "./incidents-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0eef0c2",
  null
  
)

export default component.exports